import { useDashboardOverview } from '@/features/dashboard/api';
import {
  contentListMetricsFromOverview,
} from '@/features/dashboard/platformMetrics';
import { MetricCardsRow } from '@/features/users/components/MetricCardsRow';

export function ContentMetricsStrip() {
  const { data, isLoading } = useDashboardOverview();
  const metrics = contentListMetricsFromOverview(data);

  if (isLoading) {
    return (
      <MetricCardsRow
        metrics={[
          { label: 'Total Content', value: '…' },
          { label: 'Exclusive Posts', value: '…' },
          { label: 'Total Views', value: '…' },
          { label: 'Total Purchases', value: '…' },
        ]}
      />
    );
  }

  return <MetricCardsRow metrics={metrics} />;
}
